import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  FETCH_SETTING: 'FETCH_SETTING',
  UPDATE_SETTING: 'UPDATE_SETTING',
  FETCH_SETTINGS: 'FETCH_SETTINGS',
  FETCH_INTEREST_SETTINGS: 'FETCH_INTEREST_SETTINGS',
  UPDATE_INTEREST_SETTINGS: 'UPDATE_INTEREST_SETTINGS',
  FETCH_INTEREST_SETTINGS_HISTORY: 'FETCH_INTEREST_SETTINGS_HISTORY',
  FETCH_GENERAL_CONTRACT_HISTORY: 'FETCH_GENERAL_CONTRACT_HISTORY',
  NEW_GENERAL_CONTRACT_ENTRY: 'NEW_GENERAL_CONTRACT_ENTRY',
};

export default {
  fetchSetting: settingId => {
    return apiClient.get(`/setting/${settingId}`, {
      apiCallId: apiCallIds.FETCH_SETTING,
    });
  },

  updateSetting: (settingId, settingData) => {
    return apiClient.put(`/setting/${settingId}`, settingData, {
      apiCallId: apiCallIds.UPDATE_SETTING,
    });
  },

  fetchSettings: options => {
    return apiClient.get(`/setting?pageSize=200&${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_SETTINGS,
    });
  },

  fetchInterestSettings: () => {
    return apiClient.get('/interest', {
      apiCallId: apiCallIds.FETCH_INTEREST_SETTINGS,
    });
  },

  fetchInterestSettingsHistory: () => {
    return apiClient.get('/interest/history', {
      apiCallId: apiCallIds.FETCH_INTEREST_SETTINGS_HISTORY,
    });
  },

  updateInterestSettings: interestSettings => {
    return apiClient.put('/interest', interestSettings, {
      apiCallId: apiCallIds.UPDATE_INTEREST_SETTINGS,
    });
  },

  fetchGeneralContractHistory: options => {
    return apiClient.get(`/generalContractHistory?pageSize=200&${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_GENERAL_CONTRACT_HISTORY,
    });
  },

  createNewGeneralContractEntry: (dateUpdated, role) => {
    return apiClient.post(`/generalContractHistory`, { dateUpdated, role } , {
      apiCallId: apiCallIds.NEW_GENERAL_CONTRACT_ENTRY
    })
  },
};



// WEBPACK FOOTER //
// ./src/features/setting-management/api/index.js